import moment from 'moment';
import 'moment/locale/es';
moment().local('es');

const useGetDate = () => {
    const getDate = () => moment().format('YYYY-MM-DD');
    return { getDate }
}

export default useGetDate;